import OfferingModal from "../models/OfferingInfo";

export const offeringData: OfferingModal[] = [
    {
        id: "1",
        title: "Personal 1:1 Coaching",
        description: "Private coaching for people carrying a lot who want clarity without pressure.",
        offeringLink: "https://app.coachinggenie.com/sales-page/?group=4125&product=299",
        textSections: [
            {
                sectionTitle: "Who is this for",
                sectionText: (
                    <>
                        <p>For people who appear “fine” on the outside but feel mentally overloaded and unclear on the inside.</p>
                        <p>You may be managing leadership at work, family responsibilities, personal expectations, or all of the above. From the outside, things may look “fine,”
                            but internally you feel mentally overloaded, unclear, or stuck in a constant state of pressure.</p>
                    </>
                )
            },
            {
                sectionTitle: "What this work supports",
                sectionText: (
                    <>
                        <p>Clients often come to 1:1 coaching when they want to:</p>
                        <ul>
                            <li>Calm mental noise and emotional overwhelm</li>
                            <li>Feel steadier and more present in daily life</li>
                            <li>Gain clarity around decisions or next steps</li>
                            <li>Release guilt, pressure, or internal conflict</li>
                            <li>Strengthen boundaries without over-explaining</li>
                        </ul>
                        <p>This is not about fixing yourself or doing more, it’s about creating space for clarity to return.</p>
                    </>
                )
            },
            {
                sectionTitle: "What is included",
                sectionText: (
                    <>
                        <ul>
                            <li>Energy Leadership Index assessment (ELI)</li>
                            <li>ELI Debrief (2 hours)</li>
                            <li>Values Exploration</li>
                            <li>4 Energy Blocks session</li>
                            <li>Email/text access with 6 hour response</li>
                            <li>12 private coaching sessions 60 minutes each (Zoom or phone)</li>
                        </ul>
                    </>

                )
            },
            {
                sectionTitle: "Trisha’s Signature Approach Highlights:",
                sectionText: (
                    <>
                        <p>My coaching style is calm, direct, and deeply human.</p>
                        <p>I don’t rely on pressure, rigid strategies, or constant action plans. Instead, I help quiet the noise, surface what’s true,
                            and create the conditions where insight and clarity naturally arise.</p>
                        <p>When the nervous system settles, decisions become easier.</p>
                        <p>When clarity returns, momentum follows.</p>
                    </>
                )
            },
            {
                sectionTitle: "Is 1:1 coaching right for you?",
                sectionText: (
                    <>
                        <p>Private coaching is best suited for those who:</p>
                        <ul>
                            <li>Prefer individualized support</li>
                            <li>Want a private space to reflect and process</li>
                            <li>Value depth, presence, and clarity over speed</li>
                        </ul>
                    </>
                )
            },
            {
                sectionTitle: "A note on getting started:",
                sectionText: (
                    <>
                        <p>Before beginning 1:1 coaching, I offer a brief conversation to ensure this support feels aligned and appropriate for what you’re navigating right now.</p>
                        <p>This is not a sales call — simply a chance to connect and determine fit.</p>
                        <p><b>Investment:</b><br />$2200 paid in full for 12 sessions (used as client chooses) or monthly options available.</p>
                    </>
                )
            }
        ],
        imgSrc: "/images/offering-images/one-on-one-coaching.jpg"
    },
    {
        id: "2",
        title: "Release & Realignment Collective",
        description: "A calm, facilitated space to let go of what’s heavy and move forward with clarity.",
        offeringLink: "https://app.coachinggenie.com/sales-page/?group=4125&product=292",
        textSections: [
            {
                sectionTitle: "",
                sectionText: (
                    <>
                        <p>The Release & Realignment Collective is a small, intentionally held group for people who are carrying a lot — mentally,
                            emotionally, or both — and are ready to put some of it down.</p>
                        <p>This is not a space for fixing, venting, or pushing toward goals.
                            It’s a space for reflection, perspective, and clarity to emerge naturally through conversation and shared insight.</p>
                        <p>Each group is limited to six people so everyone has time to be heard, supported, and leave each session feeling calmer and clearer.</p>
                    </>
                )
            },
            {
                sectionTitle: "What to Expect",
                sectionText: (
                    <>
                        <ul>
                            <li>Weekly 90-minute facilitated sessions</li>
                            <li>Time for each person to share a win and a challenge</li>
                            <li>Thoughtful reflections and perspectives from the group</li>
                            <li>Gentle guidance to help clarity emerge without pressure</li>
                            <li>Space to release emotional and mental weight</li>
                            <li>A clear takeaway or insight to carry forward</li>
                        </ul>
                        <p>People often leave sessions feeling more grounded, more present, and clearer about their next step — without forcing anything.</p>
                    </>
                )
            },
            {
                sectionTitle: "This Collective is for you if:",
                sectionText: (
                    <ul>
                        <li>You’re feeling mentally or emotionally overloaded</li>
                        <li>You value thoughtful conversation and reflection</li>
                        <li>You’re open to hearing perspectives from others</li>
                        <li>You want clarity without pressure or performance</li>
                    </ul>
                )
            },
            {
                sectionTitle: "This space may not be a fit if:",
                sectionText: (
                    <>
                        <ul>
                            <li>You’re looking for advice, fixing, or step-by-step strategies</li>
                            <li>You need to vent without reflection</li>
                            <li>You’re not open to group conversation</li>
                            <li>You want fast answers rather than deeper clarity</li>
                        </ul>
                    </>
                )
            },
            {
                sectionTitle: "A note on joining:",
                sectionText: (
                    <>
                        <p>Because this is an intimate and emotionally grounded space, I speak with each person briefly before they join
                            to ensure the Collective feels supportive and aligned for both of us.</p>
                        <p>This is not a sales call — it’s simply a chance to connect, answer questions, and make sure this container is the right fit.</p>
                        <p>If it feels aligned, you’ll receive the enrollment details to review and decide in your own timing.</p>
                        <p><b>Investment:</b><br />$900 paid in full or<br />$310 per month for 3 months<br />Bring a friend to the collective, receive $75 off!</p>
                    </>
                )
            }
        ],
        imgSrc: "/images/offering-images/empowering-womens-collective.png"
    }
]